import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { AppContext } from 'commons-ui';
import { isNil, isNaN, isEmpty } from 'lodash';
import { ContentPropsT } from './constants';
import { GAME_NAME } from '../constants';

const useContent = (props: ContentPropsT) => {
	const { handleFilterSubmit, onClose } = props;

	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();

	const handleFormSubmit = async (submittedData: any) => {
		try {
			setShowLoader(true);
			const { tournamentID, dateRange, gameName, pwfInviteId, tournamentType } = submittedData;

			if (!isNil(tournamentID) && !isNaN(tournamentID)) {
				handleFilterSubmit({ tournamentID, gameName });
			}

			if (!isNil(tournamentType) && !isEmpty(tournamentType) && !isNil(pwfInviteId) && !isNaN(pwfInviteId)) {
				handleFilterSubmit({ pwfInviteId, tournamentType, gameName });
			}

			if (!isNil(dateRange) && dateRange.length === 2) {
				handleFilterSubmit({
					registeredFrom: dateRange[0].getTime(),
					registeredTill: dateRange[1].getTime() + 86400000,
					gameName,
					...(isEmpty(tournamentType) ? {} : { tournamentType })
				});
			}

			const querySearchParams = new URLSearchParams(location.search);
			querySearchParams.set(GAME_NAME, gameName);
			history.replace({ pathname: location.pathname, search: querySearchParams.toString() });
			setShowLoader(false);
		} catch (error) {
			showAlert('Error in fetching user tournaments', { type: 'error' });
		} finally {
			onClose();
		}
	};

	const handleFormCancel = () => {
		onClose();
	};

	return {
		showLoader,
		setShowLoader,
		handleFormSubmit,
		handleFormCancel
	};
};

export default useContent;
